import React from 'react';

/**
 * Botão oficial do Livro de Reclamações Eletrónico.
 * Usa o logótipo oficial fornecido.
 * Liga para https://www.livroreclamacoes.pt/Inicio/
 */
const COMPLAINTS_LOGO_URL =
  'https://media.base44.com/images/public/691220492173ae6cbe68ab07/05a9f30f1_17843825776311007907234854334524.png';

export default function ComplaintsBookButton({ className = '', height = 48 }) {
  return (
    <a
      href="https://www.livroreclamacoes.pt/Inicio/"
      target="_blank"
      rel="noopener noreferrer"
      title="Livro de Reclamações Eletrónico"
      aria-label="Livro de Reclamações Eletrónico"
      className={`inline-flex items-center transition-transform hover:scale-105 ${className}`}
    >
      <img
        src={COMPLAINTS_LOGO_URL}
        alt="Livro de Reclamações Online"
        style={{ height: `${height}px`, width: 'auto' }}
        className="shrink-0"
      />
    </a>
  );
}